import { useState } from "react";
import { data, dataModalLike, dataModalDislike } from "./Interfaces";
import { Link } from "../../api/models"

export const useKeepData = () => {
    const [data, setData] = useState<data>({ messageId: "", question: "", answer: "",scope:"", negocio:"",acceso:"",centro:"",links:[],azs_links:[], date: "", time: "", question_intention: "", selected_button: "", language: "", chain_of_thought: "" });

    const setMessageId = (messageId: string) => setData(Object.assign(data, { messageId }));
    const setQuestion = (question: string) => setData(Object.assign(data, { question }));
    const setAnswer = (answer: string) => setData(Object.assign(data, { answer }));
    const setScope = (scope: string) => setData(Object.assign(data, { scope }));
    const setNegocio = (negocio:string) => setData(Object.assign(data, { negocio }));
    const setAcceso = (acceso:string) => setData(Object.assign(data, { acceso }));
    const setCentro = (centro:string) => setData(Object.assign(data, { centro }));
    const setLinks = (links:Link[]) => setData(Object.assign(data, { links }));
    const setAzsLinks = (azs_links:Link[]) => setData(Object.assign(data, { azs_links }));
    const setDate = (date: string) => setData(Object.assign(data, { date }));
    const setTime = (time: string) => setData(Object.assign(data, { time }));
    const setQuestionIntention = (question_intention: string) => setData(Object.assign(data, { question_intention }));
    const setSelectedButton = (selected_button: string) => setData(Object.assign(data, { selected_button }));
    const setChainOfThought = (chain_of_thought: string) => setData(Object.assign(data, { chain_of_thought }));
    const setLanguage = (language: string) => setData(Object.assign(data, { language }));


    return {
        data,
        setMessageId,
        setQuestion,
        setAnswer,
        setScope,
        setNegocio,
        setAcceso,
        setCentro,
        setLinks,
        setAzsLinks,
        setDate,
        setTime,
        setQuestionIntention,
        setSelectedButton,
        setChainOfThought,
        setLanguage
    };
};

// export const useKeepDataModalLike = () => {
//     const [data, setData] = useState<dataModalLike>({ comments: "" });

//     const setComments = (comments: string) => setData(Object.assign(data, { comments }));

//     return {
//         data,
//         setComments
//     };
// };
